import { render } from "./SegmentationComplexProperty.vue?vue&type=template&id=f47381bc&scoped=true"
import script from "./SegmentationComplexProperty.vue?vue&type=script&lang=ts"
export * from "./SegmentationComplexProperty.vue?vue&type=script&lang=ts"

import "./SegmentationComplexProperty.vue?vue&type=style&index=0&id=f47381bc&lang=scss"
import "./SegmentationComplexProperty.vue?vue&type=style&index=1&id=f47381bc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f47381bc"

export default script